<template>
  <div class="container shadow nav-502-parent my-4">
    <div class="d-print-none">
      <div class="navbar nav-top-border navbar-light navbar-expand-lg">

     <slot>
       <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
               aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
         <span class="navbar-toggler-icon"></span>
       </button>
     </slot>

        <m-a class="navbar-brand navbar-brand-sm navbar-toggler border-0" href="#">
          <m-a :href="{name:'Home'}">
            <m-img :src="findAttributeOnSiteInfo('icon')[0]" height="130"/>
          </m-a>
        </m-a>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">

          <div class="text-right  order-2 col-lg-6 text-lg-center">
            <m-menu3 class="d-inline-block nav307-menu" :menu-position="menuPosition">

            </m-menu3>


          </div>

          <m-a class=" order-1 navbar-brand navbar-brand-general d-none d-lg-block" href="#">
            <m-a :href="{name:'Home'}">
              <m-img :src="findAttributeOnSiteInfo('icon')[0]" height="100"/>
            </m-a>
          </m-a>


          <ul class="order-3 navbar-nav text-center align-items-center mr-auto">


            <li class="nav-item">
              <m-search-input-501/>
            </li>
            <li class="nav-item nav-link p-1 ">
              <m-language-changer1/>
            </li>

            <div v-if="shoppingCart">

              <li v-if="isAuth  || findAttributeOnSiteInfo('cartType') == 1" class="nav-link p-1 ">

                <router-link class="text-decoration-none " :to="{name:'ShoppingCart'}">
                  <button class=" d-flex align-items-center position-relative shopping-button">
                    <i class="bi bi-bag font-weight-bold text-muted  "></i>
                    <m-shopping-cart-counter1/>
                  </button>
                </router-link>

              </li>


              <li v-else class="nav-link p-1  shopping-button-parent">
                <router-link class="text-decoration-none" :to="{ name: 'UnAuthenticatedShoppingCart' }">
                  <button class=" d-flex  align-items-center position-relative shopping-button">
                    <i class="bi bi-bag font-weight-bold text-muted "></i>
                    <m-shopping-cart-counter1/>
                  </button>
                </router-link>
              </li>

            </div>
            <li class="nav-item nav-link p-1 btn btn-primary rounded-pill btn-login-style">

              <m-a :href="dashboardLink" v-if="isAuth" class="nav-link text-dark mt-2">
                {{ dashboardButtonText }}
              </m-a>
              <m-a :href="AuthLink" v-else class="nav-link text-dark p-1">
                <span>
                  {{ dashboardButtonText }}

                </span>
              </m-a>


            </li>
          </ul>


        </div>


      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem";
import mImg from '../../Tags/Img'
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon'
import mLanguageChanger1 from "../../Language/LanguageChanger/LanguageChanger1";
import mSearchInput501 from "../../Search/Input/SearchInput501";
import mShoppingCartCounter1 from "../../ShoppingCart/ShoppingCartCounter/ShoppingCartCounter1";
import mBaseMenuItem from "../../Menu/BaseMenuItem.vue";
import mMenu3 from "../../Menu/Menu3.vue";

export default {
  name: "Nav2",
  props: {
    shoppingCart: {
      type: Boolean,
      default: true,
    },
    dashboardLink: {
      default: 'https://mixitweb.com'
    },
    AuthLink: {
      default: {name: 'Login'}
    }
  },
  components: {
    mMenu3,
    mBaseMenuItem, NavMenuItem, mImg, mIcon, mA, mLanguageChanger1, mSearchInput501, mShoppingCartCounter1,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getAllMenus",
      isAuth: "User/isAuthenticated",
      orderCount: 'ShoppingCart/getSidebarBasketData',
    }),
    dashboardButtonText() {
      if (!this.isAuth) {
        return this.$t('nav.dashboard_un_auth')
      }
      return this.$t('nav.dashboard_auth')
    }
  },
};
</script>

<style scoped>
.nav-logo {
  height: 60px;
}

.nav-502-parent {
  border-radius: 50px;


}

.navbar-brand img {
  height: 55px;
}

.nav502-fingerprint-icon::before {
  font-size: 10px;
  color: white;
}


/* Base styles for dropdown */
.nav-502-parent :deep(.dropdown-menu) {
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
  display: block;
  visibility: hidden; /* Keeps the element out of sight when closed */
  border-radius: 10px;
}

/* Opening animation */
.nav-502-parent :deep(.dropdown-menu.show) {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}

/* Closing animation - delays visibility change */
.nav-502-parent :deep(.dropdown:hover .dropdown-menu:not(.show)) {
  opacity: 0;
  transform: translateY(10px);
  visibility: hidden;
  transition-delay: 0s, 0s, 0.3s; /* Delays visibility to allow opacity and transform transitions */
}

.nav-502-parent :deep(.shopping-cart-counter-1) {
  position: relative;
  top: 9px;
  right: -30px;
  font-size: 10px;
  width: 15px;
  background-color: var(--primary);

}

.shopping-button {
  width: 40px;
  border: unset;
  background-color: transparent;
  font-size: 25px;


}

.nav-502-parent :deep(.search-input-2) {
  translate: 0px 2px;


}

.nav-502-parent :deep(.search-input-2-icon) {

  font-size: 25px;
  color: gray;


}

.btn-login-style {
  font-size: 12px;
  color: black;

}

.base-menu-item-wrapper {
  display: block;


}

@media only screen and (max-width: 991px) {
  .nav-502-parent :deep(.base-menu-item-wrapper) {
    display: block !important;
    text-align: right !important;
    margin-top: 10px !important;
  }
}


</style>